import { Component, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { Observable } from 'rxjs';
import { ControlBase } from 'src/app/core/shared/models/control-base';
import { BnplService } from '../../shared/services/bnpl.service';
import { Router } from '@angular/router';
import { Parameter } from '../../shared/models/parameters.model';
import { ThridStep } from '../../shared/models/thrid-step.model';
import { IdentityvalidationService } from '../../shared/services/identityvalidation.service';
import { ValidationStrategy } from '../../shared/models/validation-strategy-response.model';
import { Client } from '../../shared/models/client.model';
import Swal from 'sweetalert2';
import { DataInformation } from '../../shared/models/data-information.model';
import { MatDialog } from '@angular/material/dialog';
import { DialogComponent } from 'src/app/core/components/dialog/dialog.component';
import { Title } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-selection-fees',
  templateUrl: './selection-fees.component.html',
  styleUrls: ['./selection-fees.component.css'],
})
export class SelectionFeesComponent implements OnInit {
  public selectionFees$: Observable<ControlBase<any>[]>;
  desabledButton: boolean = true;
  public maxCreditTerm: string = '';
  public minCreditTerm: string = '';
  public arrayFees: number[] = [];
  public dataInformation!: DataInformation;
  public mostrarReferencia: string = '';
  public selectedBranchStore: Client | null = null;
  aliado: string = '';
  public commerce: string = localStorage.getItem('commerce') || '';
  storesList = new Map<string, Client[]>();
  storeSelected: Client[] | null = null;
  urlImage: string = environment.urlAwsImg;
  carouselTuto: boolean = true;
  public clientSelected!: Client;
  public branchFinder: string = '';
  public findListBranchs: Client[] | null = null;

  constructor(
    private bnplService: BnplService,
    private readonly identityValidationService: IdentityvalidationService,
    private readonly router: Router,
    public dialog: MatDialog
  ) {
    this.selectionFees$ = this.bnplService.getSelectionFeesControls();
    this.dataInformation = this.bnplService.personalInformation;
    if (this.dataInformation.ammount) {
      this.mostrarReferencia = 'mostrarReferencia';
      this.bnplService.clients.subscribe((resp: Client[]) => {
        const [client] = resp.filter(
          (client) => client.id === this.dataInformation.client
        );
        this.clientSelected = client;
        this.aliado = this.clientSelected.partnerName;
        this.getClientSelected(this.clientSelected);
      });
    } else {
      this.mostrarReferencia = 'mostrarFormulario';
    }
  }

  ngOnInit() {
    this.handleListStores();
  }

  get storesListEntries(): [string, Client[]][] {
    return Array.from(this.storesList.entries());
  }

  getClientSelected(store: Client) {
    this.branchFinder = store.partnerName;
    this.findListBranchs = null;
    if (
      store.blockTrade == 1 &&
      this.mostrarReferencia == 'mostrarFormulario'
    ) {
      this.desabledButton = true;
      this.dialog.open(DialogComponent, {
        data: {
          img: `${environment.urlAwsImg}/${store.id}.png`,
          description: store.blockMessage,
          descriptionSmall: store.blockMessageSmall
            ? store.blockMessageSmall
            : '',
          button: 'Volver',
          url: store.urlBackbuttom,
        },
        width: '60%',
        height: '60vh',
      });
    } else {
      localStorage.setItem('partnerName', store.partnerName);
      localStorage.setItem('partner', store.id);
      this.desabledButton = false;
    }
  }

  // filterClient(dataId: string) {
  //   let filter: Client | any;
  //   this.bnplService.clients.subscribe((resp: Client[]) => {
  //     filter = resp.filter((client: Client) => client.id === dataId);
  //     this.getClientSelected(filter[0]);
  //   });
  // }

  getSelectionFees(numeroCuotas?: ThridStep) {
    this.router.navigate(['/await-alert', 'espera']);
  }

  handleListStores() {
    this.bnplService.getClients().subscribe({
      next: (response) => {
        response.forEach((store) => {
          const key = store.brand;

          if (!this.storesList.has(key)) {
            this.storesList.set(key, []);
          }

          this.storesList.get(key)?.push(store);
        });
        console.log(this.storesList);
      },
      error: (error) => {
        console.error('Error al obtener el estado', error);
      },
    });
  }

  handleCarouselMaskTutoTimer(value: boolean) {
    this.carouselTuto = true;
    setTimeout(() => {
      this.handleCarouselMaskTuto(value);
    }, 5000);
  }

  handleCarouselMaskTuto(value: boolean) {
    this.carouselTuto = value;
  }

  filteredBranchs() {
    this.findListBranchs = null;
    this.selectedBranchStore = null;
    if (this.storeSelected) {
      const branch = this.branchFinder.toLowerCase();
      this.findListBranchs = this.storeSelected.filter((store) =>
        store.partnerName.toLowerCase().includes(branch)
      );
    }
  }

  handleResetBranch() {
    this.findListBranchs = null;
    this.selectedBranchStore = null;
    this.branchFinder = '';
  }
}
